module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/th_shikoku-0ba0456017a35fd8884a5d8aad26d264.jpg";